import React, { useMemo } from 'react'
import noop from 'lib/function/noop'
import styled from 'styled-components'
import OfferAirportOptionsGroupedList from '../Airport/OfferAirportOptionsGroupedList'
import { useAppSelector } from 'hooks/reduxHooks'

const Wrapper = styled.div`
  position: relative; /* to make the <LoadingIndicator> work  */
`

interface Props {
  selectedAirport?: App.Airport
  onSelectAirport?: (airport: App.AirportLocation) => void
  withRadioButtons?: boolean
}

function CharterFlightOfferAirportOptionsList(props: Props) {
  const {
    selectedAirport,
    onSelectAirport = noop,
    withRadioButtons,
  } = props

  // Get all Australian airports from Redux state
  const australianAirports = useAppSelector(state => state.geo.originAirports)

  // Filter to show only Australian airports
  const airports = useMemo(() => {
    return australianAirports.filter(airport => airport.countryCode === 'AU')
  }, [australianAirports])

  return <Wrapper>
    <OfferAirportOptionsGroupedList
      airports={airports}
      handleItemClick={onSelectAirport}
      selectedAirport={selectedAirport}
      withRadioButtons={withRadioButtons}
    />
  </Wrapper>
}

export default CharterFlightOfferAirportOptionsList
